export default "__VITE_ASSET__Ce9c6KSw__"